import {createApp} from 'vue';
import App from './App.vue';
import router from '@/router';
import ElementPlus from 'element-plus';
import VueCookies from 'vue-cookies';
import 'element-plus/dist/index.css';
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/style/common.css';
import VueWechatTitle from 'vue-wechat-title';


let app = createApp(App);

app.use(router).use(ElementPlus).use(VueCookies).use(VueWechatTitle).mount('#app');
